import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  background: #ffffff;
  border-radius: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f5f5f5;
`;

export const ListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;

  & + & {
    border-top: 1px solid #f5f5f5;
  }
`;

export const RowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const TextLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RowRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
`;
